import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import type { RecordModificationResponse } from "#root/utility/remote-data";
import type { ReactNode } from "react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { currencyCollection, domicileCollection, type DomicileListItem } from "#root/schema/platform/reference-data";
import PageLayout from "./layout";

export default function ({ domicileId }): ReactNode {
  const navigate = useNavigate();
  const handleUpdate = useCallback(
    (data: RecordModificationResponse<DomicileListItem>) => {
      if ("deleted" in data) {
        navigate("/admin/platform/reference/domicile");
      } else if ("created" in data) {
        navigate(`/admin/platform/reference/domicile/${data.created}`);
      }
    },
    [navigate],
  );

  return (
    <PageLayout title="Reference Data Platform - Edit Domicile">
      <section>
        <h2>{domicileId === "new" ? "Create" : "Edit"} Domicile</h2>
        <StandardEditor id={domicileId} collection={domicileCollection} onSave={handleUpdate} onDelete={handleUpdate}>
          <Fields.Set name="id">
            <label>Domicile Id</label>
            <Fields.Integer required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="name">
            <label>Domicile Name</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="isoCode">
            <label>Domicile ISO Code</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="flag">
            <label>Domicile Flag Filename</label>
            <Fields.String required/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="defaultCurrency">
            <label>Default Currency for Domicile</label>
            <Fields.AutoComplete required collection={currencyCollection}/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
